module.exports = __webpack_public_path__ + "static/img/icon_payment_fail_bg.fb6ba95.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_payment_fail_bg.svg
// module id = 8hym
// module chunks = 10